import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Input,
} from "reactstrap";
import "./modelcss.css";

function InsertCategoryModel({
  OnToggle,
  view,
  onUpdateHeadMap,
  updateCategory,
  cancel,
  values,
}) {
  return (
    <div>
      <Modal isOpen={view} toggle={OnToggle} fullscreen={"false"}>
        <ModalBody>
          <Row xs="4">
            <Col>Name</Col>
            <Col>
              <Input
                bsSize="sm"
                className="mb-3"
                type="text"
                name="name"
                id="name"
                onChange={onUpdateHeadMap}
                value={values.name || ""}
              />
            </Col>
            <Col>Type</Col>
            <Col>
              <Input
                type="select"
                name="type"
                id="type"
                onChange={onUpdateHeadMap}
                value={values.type || ""}
              >
                <option value="0">Select</option>
                <option value="IN">Income</option>
                <option value="OUT">Expense</option>
              </Input>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={updateCategory}>
            Save
          </Button>
          <Button color="secondary" onClick={cancel}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default InsertCategoryModel;



// WEBPACK FOOTER //
// ./src/components/CustomComponents/InsertCategoryModel.js